import { TFunction } from 'react-i18next';
import { ErrorDetails, KizenStepType, HistoryStatus } from './types';

export const errorsToShow = (item: ErrorDetails) =>
  item.error || item.errorDescription;

export const linksToShow = (item: ErrorDetails) =>
  item.error || item.errorDescription || item.detailedLog;

const errorStatus: HistoryStatus[] = ['failed'];

export const errorByStatus = (status: HistoryStatus) =>
  errorStatus.includes(status);

const pendingStatus: HistoryStatus[] = ['pending', 'pending_throttled'];

export const pendingByStatus = (status: HistoryStatus) =>
  pendingStatus.includes(status);

export const pasteStepTypeNameLookup = (
  stepType: KizenStepType,
  t: TFunction
) => {
  switch (stepType) {
    case 'goal':
      return t('Goal');

    case 'condition':
      return t('Condition');

    case 'delay':
      return t('Delay');

    default:
      return t('Action');
  }
};
